module.exports = __webpack_public_path__ + "static/media/on.27427435.svg";